// Centralised WhatsApp helpers for Neuro Rehabs.
export const WHATSAPP_NUMBER = "919005767229";
export const CLINIC_PHONE_DISPLAY = "+91 90057 67229";
export const CLINIC_PHONE_TEL = "+919005767229";
export const CLINIC_EMAIL = "jgauravkumar1503@gmail.com";

export const buildWhatsAppGenericUrl = (
  text = "Hello Doctor, I would like to know more about your physiotherapy services.",
) => `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(text)}`;

export const buildBookingMessage = (booking) => {
  const lines = [
    "Hello Doctor,",
    "",
    "I would like to book a physiotherapy appointment.",
    "",
    "*Patient Details*",
    `Name: ${booking.name || "-"}`,
    `Phone: ${booking.phone || "-"}`,
    `Age: ${booking.age || "-"}`,
    `Gender: ${booking.gender || "-"}`,
    `Location: ${booking.location || "-"}`,
    `Doctor Preference: ${booking.doctorPreference || "-"}`,
    "",
    "*Treatment*",
    `Treatment: ${booking.treatmentName || "-"}`,
    `Duration: ${booking.duration} day${booking.duration > 1 ? "s" : ""}`,
    `Price Per Day: ₹${booking.pricePerDay}`,
    `Total Amount: ₹${booking.total}`,
    "",
    "Please confirm my appointment.",
  ];
  return lines.join("\n");
};

export const buildBookingWhatsAppUrl = (booking) =>
  `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(buildBookingMessage(booking))}`;
